import { SubState } from '../state';
import { AppState } from '../state.module';
import { StepGuard } from '../../core/model/step-guard';

export class KaskoState implements SubState {

  constructor(
    private _parent: AppState = null,
    private _step: StepGuard = new StepGuard(),
    private _kaskoId: string = null,
    private _brand: string = null,
    private _model: string = null,
    private _purchasePhoneAmount: number = null,
    private _imei: string = null,
    private _imgReceiptUrl: string = null,
    private _note: string = null,
    private _purchaseDate: string = null, // DD/MM/YYYY
    private _customerType: string = null,
    private _customerId: string = null,
    private _paymentId: string = null,
  ) { }

  get parent(): AppState {
    return this._parent;
  }

  get step(): StepGuard {
    return this._step;
  }

  get kaskoId(): string {
    return this._kaskoId;
  }

  get brand(): string {
    return this._brand;
  }

  get model(): string {
    return this._model;
  }

  get purchasePhoneAmount(): number {
    return this._purchasePhoneAmount;
  }

  get imei(): string {
    return this._imei;
  }

  get imgReceiptUrl(): string {
    return this._imgReceiptUrl;
  }

  get note(): string {
    return this._note;
  }

  get purchaseDate(): string {
    return this._purchaseDate;
  }

  get customerType(): string {
    return this._customerType;
  }

  get customerId(): string {
    return this._customerId;
  }

  get paymentId(): string {
    return this._paymentId;
  }


  withParent(parent: AppState): KaskoState {
    return new KaskoState(
      parent,
      this._step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      this._customerId,
      this._paymentId,
    );
  }

  addCurrentWizzardStep(step: StepGuard): AppState {
    return this._parent.withKasko(this.recreate(
      step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      this._customerId,
      this._paymentId,
    ));
  }

  addKaskoId(kaskoId: string): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      this._customerId,
      this._paymentId,
    ));
  }

  addInitInfo(brand: string, model: string, purchasePhoneAmount: number): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      this._kaskoId,
      brand,
      model,
      purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      this._customerId,
      this._paymentId,
    ));
  }

  addPhoneInfo(imei: string, imgReceiptUrl: string, note: string, purchaseDate: string): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      imei,
      imgReceiptUrl,
      note,
      purchaseDate,
      this._customerType,
      this._customerId,
      this._paymentId,
    ));
  }

  addKaskoCustomerType(customerType: string): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      customerType,
      this._customerId,
      this._paymentId,
    ));
  }

  addKaskoCustomerId(customerId: string): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      customerId,
      this._paymentId,
    ));
  }

  AddKaskoPaymentId(paymentId: string): AppState {
    return this._parent.withKasko(this.recreate(
      this._step,
      this._kaskoId,
      this._brand,
      this._model,
      this._purchasePhoneAmount,
      this._imei,
      this._imgReceiptUrl,
      this._note,
      this._purchaseDate,
      this._customerType,
      this._customerId,
      paymentId,
    ));
  }

  private recreate(
    step: StepGuard,
    kaskoId: string,
    brand: string,
    model: string,
    purchasePhoneAmount: number,
    imei: string,
    imgReceiptUrl: string,
    note: string,
    purchaseDate: string,
    customerType: string,
    customerId: string,
    paymentId: string,
  ): KaskoState {
    return new KaskoState(
      null,
      step,
      kaskoId,
      brand,
      model,
      purchasePhoneAmount,
      imei,
      imgReceiptUrl,
      note,
      purchaseDate,
      customerType,
      customerId,
      paymentId
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/state/kasko/kasko-state.ts